<template>
  <span
    :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
    class="ls-clickable"
    :class="themedClass"
    test-id="ls-clickable"
    :aria-label="trackId"
    role="button"
    tabindex="0"
    @click="onClick"
    @mouseover="!disabled && $emit('mouseover')"
    @mouseleave="!disabled && $emit('mouseleave')"
    ><slot
  /></span>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsClickable',
  mixins: [themedComponentMixin],
  props: {
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    disabled: VueTypes.bool.def(false),
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      lsTrackingService.track({ event: 'click', target: this.trackId });
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-clickable {
  outline: none;
  &:active {
    outline: 1px dashed $primary-light;
  }
}

.themed-component {
  &.ls-clickable:active {
    outline: 1px dashed $theme-color-primary-light;
  }
}
</style>
